import { useAsync } from 'react-async-hook';
import { INVITE_STATUS, useInviteStore } from '../store/use-invite-store';
import { api } from './instance';
import { transformApiBooking } from './utils';

export async function getInvite(inviteReference, setInvite) {
  try {
    const data = await api.auth.get(`onlinebooking/${inviteReference}`).json();
    const transformed = transformApiBooking(data);
    setInvite(transformed);
    return transformed;
  } catch (error) {
    if (error.response?.status >= 400 && error.response?.status < 500) {
      setInvite({ status: INVITE_STATUS.INVALID });
    } else {
      throw error;
    }
  }
}

export function useGetInvite(inviteReference) {
  const { setInvite } = useInviteStore();
  return useAsync(getInvite, [inviteReference, setInvite]);
}
